function sdrn(id, platform) {
  return 'sdrn:' + platform + ':experiment:' + id;
}

/** */


/** */


function formatExperiment(experiment) {
  var _ref = experiment || {},
      id = _ref.id,
      platform = _ref.platform,
      layer = _ref.layer,
      variant = _ref.variant,
      forced = _ref.forced;

  var formattedExperiment = {
    '@id': sdrn(id, platform),
    variant: variant
  };
  if (layer) {
    formattedExperiment.layer = layer;
  }
  if (forced) {
    formattedExperiment.forced = forced;
  }
  return formattedExperiment;
}

/* eslint consistent-return: 0 */
/**
 * Format experiments
 */
export default function experiments(input) {
  var experimentList = (input || {}).experiments || [];
  if (experimentList.length > 0) {
    return experimentList.map(formatExperiment);
  }
}

export function defaultValue() {}